<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-i">For<br/>Tacklow,<br/>who once told me that<br/>on a clear day, from a<br/>certain hillside above the<br/>road to Simla, one could ‘see<br/>forever’.</span></p>
<p class="img"><img alt="image" height="154" src="images/logo.jpg" width="153"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?6f4c03e6